import React, { useState } from "react";
import Nav from "./Nav";
import { Button, Form, FormGroup, Input, Label, Spinner } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { login } from "../../services/loginApi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const validInput = () => {
    if (!userName && !password) {
      setError("IDとパスワードを入力してください");
      setIsLoading(false);
      return false;
    } else if (!userName) {
      setError("ユーザー名を入力してください");
      return false;
    } else if (!password) {
      setError("パスワードを入力してください");
      return false;
    }
    setError("");

    return true;
  };

  const handleLogin = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    if (validInput()) {
      const isAuthed = await login(userName, password);

      if (isAuthed !== null) {
        navigate("/location-select");
      } else {
        setError("間違ったユーザー名またはパスワード ");
        setTimeout(() => setError("IDとパスワードを入力してください"), 5000);
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <Nav />
      <div className="">
        <div className="login mx-auto my-auto">
          <div className="mt-3">
            <h5 className="text-center loginHeading">ログイン</h5>
            <p className="text-center loginSubHeading">
              ユーザー名とパスワードを入力してください
            </p>
          </div>

          <Form className="mt-5" onSubmit={handleLogin}>
            <FormGroup className="mx-3">
              <Label for="userName">
                <img src="./person.png" className="me-1" alt="user" />
                <span className="labelFont">ユーザー名:</span>
              </Label>
              <Input
                id="userName"
                name="userName"
                type="text"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                className="inputBorder"
              />
            </FormGroup>

            <FormGroup className="mx-3 position-relative">
              <Label for="examplePassword">
                <img src="./Lock.png" className="me-1" alt="lock" />
                <span className="labelFont">パスワード:</span>
              </Label>

              <div style={{ position: "relative" }}>
                <Input
                  id="examplePassword"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{ paddingRight: "2.5rem" }}
                  className="inputBorder"
                />

                <FontAwesomeIcon
                  icon={showPassword ? faEyeSlash : faEye}
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    width: "15px",
                    height: "15px",
                  }}
                />
              </div>
            </FormGroup>

            {error && <p className="text-danger text-center">{error}</p>}

            <div className="d-flex justify-content-center mt-5">
              <Button type="submit" className="loginButton">
                {isLoading ? (
                  <>
                    {" "}
                    <Spinner size="sm">Loading...</Spinner>
                    <span> お待ちください</span>
                  </>
                ) : (
                  "OK"
                )}
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default Login;
